module.exports = {
    /*
     * Google maps
     */
    CLASS_GOOLEMAPS_MAP : '.js-googlemaps-map',
    CLASS_NEAREST_STORE : '.js-googlemaps-nearestStore',
    CLASS_NEAREST_STORE_NAME : 'js-googlemaps-nearestStore',
    CLASS_SELECT_STORE : '.js-googlemaps-selectStore',
    CLASS_ADDRESS_STORE : '.js-googlemaps-address',
    CLASS_STORE_RADIUS: '.js-googlemaps-radius',
    CLASS_NEAREST_STORES_BLOCK : '.js-googlemaps-nearestStoresBlock',
    CLASS_SELECTED_STORE_BLOCK : '.js-googlemaps-selectedStoreBlock',
    CLASS_SHOW_NEAREST_STORE_LINK : '.js-googlemaps-showNearestStoresLink',
    CLASS_NEAREST_STORE_RADIO_BTN : '.js-googlemaps-nearestStoreRadioBtn',
    CLASS_NEAREST_STORE_RADIO_BTN_NAME : 'js-googlemaps-nearestStoreRadioBtn',
    CLASS_GOOFLEMAPS_TABS : '.js-googlemaps-tabs',
    CLASS_SELECTED_STORE_FOR_COLLECTION : '.js-googlemaps-selectedStoreForCollection',
    CLASS_FAKE_LINK : '.js-fakeLink',
    CLASS_MSG_BOX_CONTAINER: '.js-msgBoxContainer',
    CLASS_PROCEED_TO_PAYMENT_BTN: '.js-proceedToPaymentBtn',
    CLASS_AZ_VIEW_CONTAINER: '.js-googlemaps-azViewContainer',
    CLASS_FIND_BTN: '.js-googlemaps-findBtn',
    CLASS_SEARCH_BY_CURRENT_LOCATION: '.js-googlemaps-search-by-current-location',
    CLASS_BROWSE_AZ_BTN: '.js-googlemaps-browseAZ',
    CLASS_AZ_VIEW: '.js-store-azView',
    CLASS_MAP_VIEW: '.js-store-mapView',
    CLASS_MOBILE_TABS: '.js-googlemaps-mobileTabs',
    CLASS_MOBILE_TAB: '.js-googlemaps-mobileTab',
    CLASS_MOBILE_TAB_LOCATIONS: '.js-googlemaps-mobileTab-locations',
    CLASS_MOBILE_TAB_MAP: '.js-googlemaps-mobileTab-map',
    CLASS_MOBILE_PANEL_LOCATIONS: '.js-googlemaps-mobilePanel-locations',
    CLASS_MOBILE_PANEL_MAP: '.js-googlemaps-mobilePanel-map',
    CLASS_MOBILE_SELECTED_STORE_BLOCK: '.js-googlemaps-mobileSelectedStoreBlock',
    CLASS_ALPHABET_TITLE: '.js-alphabet-title',
    CLASS_ALPHABET_ACTIVE: 'alphabet-title_active',
    CLASS_ALPHABET_CONTAINER: '.js-alphabet-container',
    CLASS_ALPHABET_CLOSE: 'alphabet-store_close',
    CLASS_STORE_CONTAINER: '.js-neareStore-container',
    CLASS_STORE_CONTAINER_NAME: 'js-neareStore-container',
    CLASS_STORE_TITLE: '.js-neareStore-title',
    CLASS_REFINEMENT_ERROR: '.js-refinementBoxContainer',
    CLASS_LINK_DETAIL_PAGE: '.js-link-detailpage',
    CLASS_STORE_RESULTS_INFO: '.js-store-results-info',
    CLASS_STORE_LIVE_ANNOUNCE: '.js-store-live-announce',
    CLASS_MOBILE_RESULTS_ACTIVE: 'm-results-active',
    CLASS_MOBILE_TAB_ACTIVE: 'm-tab-active',
    CLASS_MOBILE_TAB_DISABLED: 'm-tab-disabled',
    CLASS_MOBILE_LOCATIONS_ACTIVE: 'm-locations-active',
    CLASS_MOBILE_MAP_ACTIVE: 'm-map-active',
    MOBILE_TAB_LOCATIONS: 'locations',
    MOBILE_TAB_MAP: 'map',
    BODY: 'body',
    CLASS_STORE_ACTIVE: 'store-card_container-active',
    CLASS_STORE_EMPTY: 'store-results_list-empty',
    CLASS_MAIN_WRAPPER: '.main-wrapper',
    CLASS_EXPANDABLE_CARD: '.js-store-expandable-card',
    CLASS_CARD_WIDE: 'm-wide',
    CLASS_CARD_READY: 'm-ready',
    CLASS_STORE_CARD_OVERFLOW_CHECK: '.js-store-card-overflow-check',
    CLASS_STORE_DETAILS_GRID: '.store-details_grid',
    CLASS_GRID_HAS_OVERFLOW: 'm-has-overflow',
    CLASS_GRID_READY: 'm-grid-ready',
    CLASS_STORE_EMAIL: '.store-details_email'
};
